import GenerationEvent from "../../../../contents/docs/llm-analytics/_snippets/generation-event.mdx";
import NotableGenerationProperties from "../../../../contents/docs/llm-analytics/_snippets/notable-generation-properties.mdx";
import * as React from 'react';
export default {
  GenerationEvent,
  NotableGenerationProperties,
  React
};